import { Sparkles } from 'lucide-react'
import type { ReactNode } from 'react'
import { S } from '../tokens'
import type { ShellNavModel } from '../useShellNav'

/** No screen open: the app's name and a hint (or why a linked screen is missing). */
export function EmptyPane({ model, appTitle, message, leading, accent }: {
  model: ShellNavModel; appTitle: string; message: string; leading?: ReactNode; accent?: string
}) {
  return (
    <div style={{
      flex: 1, position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 12, color: S.text2, padding: 32, textAlign: 'center', minHeight: 0,
    }}>
      {leading && <div style={{ position: 'absolute', top: 12, left: 12 }}>{leading}</div>}
      <div aria-hidden style={{
        width: 52, height: 52, borderRadius: 14, background: accent || S.accent, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Sparkles size={22} />
      </div>
      <h2 style={{ fontSize: 17, fontWeight: 600, color: S.text, margin: 0 }}>{appTitle}</h2>
      <p style={{ margin: 0, fontSize: 14, maxWidth: 360, lineHeight: 1.5 }}>
        {model.missingObjName
          ? `"${model.missingObjName}" isn't in this application's navigation, or it isn't available to your roles.`
          : message}
      </p>
    </div>
  )
}
